

import { Injectable } from '@angular/core';
import {
    CanActivate, Router,
} from '@angular/router';

import { AuthService } from './auth.service';

@Injectable()
export class AdminGuard implements CanActivate {
    constructor(private router: Router, private authService: AuthService) { }

    canActivate(): any {
        return this.verifyAdmin();
    }

    verifyAdmin(): boolean {
        const companyRoles = this.authService.getCompanyRoles();
        if (companyRoles && (companyRoles === 'owner' || companyRoles === 'admin')) {
            return true;
        } else {
          this.router.navigate(['/member']);
          return false;
        }
    }
}
